import {
  ServiceNavItem, ServiceNavBasicItem
} from '@raksul/kamii-vue'

export const SYSTEM_ERROR = {
  UNKNOWN: 'システムで問題が発生しました。時間をおいて再度お試しください。',
  TIMEOUT: '接続がタイムアウトしました。時間をおいて再度お試しください。'
}

export const GUIDE_LINK = {
  CREATE_PATH_DATA: 'https://guide.raksul.com/hc/ja/articles/6235342324623-%E3%83%91%E3%82%B9%E3%83%87%E3%83%BC%E3%82%BF%E3%81%AE%E4%BD%9C%E6%88%90%E6%96%B9%E6%B3%95'
}

export const noveltyServiceNavItems: ServiceNavItem[] = [
  {
    label: 'ノベルティマガジン',
    url: '/cms/magazine',
    target: '_blank'
  },
  {
    label: '再注文・増刷',
    url: '/orders'
  }
]

export const serviceNavBasicItems: ServiceNavBasicItem[] = [
  {
    label: 'ご利用ガイド',
    url: 'https://guide.raksul.com/hc/ja/categories/4934814196367',
    icon: 'questionCircle',
    target: '_blank'
  }
]

export const IMAGE_VARIANT = {
  WEB_CAROUSEL: 'web_carousel',
  BRAND: 'brand',
  CATEGORY_MAIN: 'category_main',
  SKU_THUMBNAIL: 'sku_thumbnail',
  SKU_MAIN: 'sku_main',
  PRODUCT: 'product',
  ARTICLE: 'article',
  CATEGORY_ICON_THUMBNAIL: 'category_icon_thumbnail',
  CATEGORY_ICON_MAIN: 'category_icon_main',
  MAGAZINE_COLUMN_THUMBNAIL: 'magazine_column_thumbnail',
  MAGAZINE_CATEGORY_THUMBNAIL: 'magazine_category_thumbnail',
  CATEGORY_BANNER: 'category_banner'
}

export const PERSONALIZE_PAGES = {
  TOP: 'top',
  PRODUCT_DETAIL: 'product_detail',
  CART: 'cart',
  FAVORITE: 'favorite',
  ORDER_HISTORY: 'order_history',
  THANKS: 'thanks'
}

export const PERSONALIZE_AREAS = {
  DEFAULT: 'default',
  RIGHT_SIDE: 'right_side',
  ABOVE_FOOTER: 'above_footer',
  SURVEY: 'survey',
  TOP_SIDE: 'top_side'
}

export const PERSONALIZE_PATTERNS = {
  PATTERN_A: 'pattern_a',
  PATTERN_B: 'pattern_b'
}
